import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function validColorValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value !== 'string') {
      return { invalidColor: true };
    }

    const color = value.trim();
    const isHex = /^#(?:[\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i.test(color);
    const isRgbOrHsl = /^(?:rgb|rgba|hsl|hsla)\(\s*[^()]+\s*\)$/i.test(color);
    const isCssFunction = /^(?:oklab|oklch|lab|lch|color|hwb|light-dark)\(\s*[^()]+\s*\)$/i.test(color);
    const isNamedColor = /^[a-z]+$/i.test(color);

    return isHex || isRgbOrHsl || isCssFunction || isNamedColor
      ? null
      : { invalidColor: true };
  };
}
